import React from 'react';
import { connect } from 'react-redux';
import className from 'classnames';

import { EMPLOYMENT_INSURANCE_MENU } from 'src/constants/Generals';
import { CLIENT_EMPLOYMENT_INSURANCE_FORM } from 'src/constants/FormNames';
import { TextField, RadioField, Label } from 'jbc-front/components/Form';
import Button from 'jbc-front/components/Button';
import * as CssClassNames from 'src/constants/CssClassNames';
import { digitFloatingNumber } from 'src/utils/CustomValidators';
import selector, { sumFloatNumberFixed5, toFloatString } from 'src/utils/Utils';
import { REDUCER_NAME, getEmploymentInsuranceFormValues } from 'src/reducers/clients/insurance';
import { getSelectOptions } from 'src/reducers/selectOptions';
import InsuranceSetting from 'src/features/Clients/components/InsuranceSetting';
import { ErrorsSection, InsurancePeriodSetting } from 'src/components';
import { getExtras } from 'src/reducers/common/listReducer';
import OrganizationNumber from './OrganizationNumber';
import HelloWork from './HelloWork';
import styles from './EmploymentInsuranceCreatingForm.scss';

const updateFields = [
  'constructionRateForEmployee',
  'constructionRateForEmployer',
  'generalRateForEmployee',
  'generalRateForEmployer',
  'insuranceType',
  'helloWorkPrefectureId',
  'helloWorkId',
  'maffRateForEmployee',
  'maffRateForEmployer',
  'organizationNumber',
  'organizationNumberPart0',
  'organizationNumberPart1',
  'organizationNumberPart2'
];

const EmploymentInsuranceCreatingForm = props => {
  const {
    submit,
    submitting,
    errors,
    handleSubmit,
    insuranceTypes,
    selectedInsuranceType,
    generalRateForEmployee,
    generalRateForEmployer,
    maffRateForEmployee,
    maffRateForEmployer,
    constructionRateForEmployee,
    constructionRateForEmployer,
    isFirstSet
  } = props;

  return (
    <div className={styles.wrap}>
      <InsuranceSetting activeMenu={EMPLOYMENT_INSURANCE_MENU}>
        <form
          className={className(
            CssClassNames.FORM,
            CssClassNames.CLIENT_INSURANCE_FORM,
            CssClassNames.CLIENT_EMPLOYMENT_INSURANCE
          )}
          onSubmit={handleSubmit}
        >
          <ErrorsSection errors={errors} />

          <OrganizationNumber />

          <HelloWork />
          <div className={styles.inner}>
            {!isFirstSet && (
              <InsurancePeriodSetting
                formName={CLIENT_EMPLOYMENT_INSURANCE_FORM}
                fieldName="settingStartDate"
                updateFields={updateFields}
                insuranceType="employmentInsurance"
              />
            )}
            <RadioField required label="業種" name="insuranceType" options={insuranceTypes} />
            <Label text="保険料率" />
            <div className="l-overflow-scroll">
              <table className={`${styles.table} m-table-list`}>
                <thead>
                  <tr>
                    <th />
                    <th>従業員負担（％）</th>
                    <th>事業主負担（％）</th>
                    <th>合計（％）</th>
                  </tr>
                </thead>
                <tbody>
                  {selectedInsuranceType === 'general' && (
                    <tr>
                      <td>一般事業</td>
                      <td>
                        <TextField type="text" name="generalRateForEmployee" validate={digitFloatingNumber} disabled />
                      </td>
                      <td>
                        <TextField type="text" name="generalRateForEmployer" validate={digitFloatingNumber} disabled />
                      </td>
                      <td>
                        <span>
                          {toFloatString(sumFloatNumberFixed5(generalRateForEmployee, generalRateForEmployer))}
                        </span>
                      </td>
                    </tr>
                  )}
                  {selectedInsuranceType === 'maff' && (
                    <tr>
                      <td>農林水産・清酒製造業</td>
                      <td>
                        <TextField type="text" name="maffRateForEmployee" validate={digitFloatingNumber} disabled />
                      </td>
                      <td>
                        <TextField type="text" name="maffRateForEmployer" validate={digitFloatingNumber} disabled />
                      </td>
                      <td>
                        <span>{toFloatString(sumFloatNumberFixed5(maffRateForEmployee, maffRateForEmployer))}</span>
                      </td>
                    </tr>
                  )}
                  {selectedInsuranceType === 'construction' && (
                    <tr>
                      <td>建設業</td>
                      <td>
                        <TextField
                          type="text"
                          name="constructionRateForEmployee"
                          validate={digitFloatingNumber}
                          disabled
                        />
                      </td>
                      <td>
                        <TextField
                          type="text"
                          name="constructionRateForEmployer"
                          validate={digitFloatingNumber}
                          disabled
                        />
                      </td>
                      <td>
                        <span>
                          {toFloatString(
                            sumFloatNumberFixed5(constructionRateForEmployee, constructionRateForEmployer)
                          )}
                        </span>
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>

          <div className="u-ta-c u-mt20">
            <Button primary disabled={submitting} onClick={submit}>
              保存
            </Button>
          </div>
        </form>
      </InsuranceSetting>
    </div>
  );
};

const mapStateToProps = state => ({
  insuranceTypes: getSelectOptions(state, 'businessTypes'),
  selectedInsuranceType: selector(getEmploymentInsuranceFormValues(state), 'insuranceType'),
  generalRateForEmployee: selector(getEmploymentInsuranceFormValues(state), 'generalRateForEmployee'),
  generalRateForEmployer: selector(getEmploymentInsuranceFormValues(state), 'generalRateForEmployer'),
  maffRateForEmployee: selector(getEmploymentInsuranceFormValues(state), 'maffRateForEmployee'),
  maffRateForEmployer: selector(getEmploymentInsuranceFormValues(state), 'maffRateForEmployer'),
  constructionRateForEmployee: selector(getEmploymentInsuranceFormValues(state), 'constructionRateForEmployee'),
  constructionRateForEmployer: selector(getEmploymentInsuranceFormValues(state), 'constructionRateForEmployer'),
  isFirstSet: selector(getExtras(REDUCER_NAME, state), 'isFirstSet')
});

export default connect(mapStateToProps)(EmploymentInsuranceCreatingForm);
